var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgCapture(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 32,
    height: 32,
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    stroke: "#191C20",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1.5,
    d: "M3 10.8V8.2A5.2 5.2 0 0 1 8.2 3h2.6m10.4 0h2.6A5.2 5.2 0 0 1 29 8.2v2.6m0 10.4v2.6a5.2 5.2 0 0 1-5.2 5.2h-2.6m-10.4 0H8.2A5.2 5.2 0 0 1 3 23.8v-1.878M8.5 24v-1.882c0-2.6 2.099-4.706 4.688-4.706h5.624c2.59 0 4.688 2.107 4.688 4.706V24m-4.219-12.706A3.288 3.288 0 0 1 16 14.588a3.288 3.288 0 0 1-3.281-3.294A3.288 3.288 0 0 1 16 8a3.288 3.288 0 0 1 3.281 3.294Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCapture);
export default __webpack_public_path__ + "static/media/capture.6c7be3985172e39eedd3527f8a6fb18e.svg";
export { ForwardRef as ReactComponent };